import $ from 'jquery';

class Search {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$page = $('.page');
        this.$openButton = $('.js-search-open');
        this.$closeButton = $('.js-search-close');
        this.$submitButton = $('.js-search-submit');
        this.$search = $('.js-search');
        this.$input = $('.js-search-input');
        this.$body = $('body');
        this.searchOpen = false;
        this.addClickHandlers();
    }

    addClickHandlers() {
        this.$openButton.on('click', e => {
            e.preventDefault();
            this.toggleSearch();
        });

        this.$closeButton.on('click', e => {
            e.preventDefault();
            this.toggleSearch();
        });
    }

    toggleSearch() {
        !this.searchOpen ? this.openSearch() : this.closeSearch();
    }

    openSearch() {
        this.searchOpen = true;
        this.$page.addClass('inactive');
        this.$search.addClass('active');
        this.$search.one('webkitTransitionEnd transitionend', () => {
            // we need to wait until transitionend to focus the input because focus() does not work on hidden elements
            this.$input.focus();
        });
        this.$body.on('keydown', e => {
            this.handleKeydown(e);
        });
    }

    closeSearch() {
        this.searchOpen = false;
        this.$page.removeClass('inactive');
        this.$search.removeClass('active');
        this.$openButton.blur();
        this.$body.off('keydown');
        $(window).scrollTop(0);
    }

    handleKeydown(e) {
        const $focused = $(e.target);

        // escape - close search
        if (e.which === 27) {
            e.preventDefault();
            this.closeSearch();

            // tab + shift - cycle backwards within nav links
        } else if (e.which === 9 && e.shiftKey) {
            e.preventDefault();
            if (this.$input.is($focused)) {
                this.$closeButton.focus();
            } else if (this.$closeButton.is($focused)) {
                this.$submitButton.focus();
            } else if (this.$submitButton.is($focused)) {
                this.$input.focus();
            } else {
                this.$input.focus();
            }

            // tab - cycle within nav links
        } else if (e.which === 9) {
            e.preventDefault();
            if (this.$closeButton.is($focused)) {
                this.$input.focus();
            } else if (this.$input.is($focused)) {
                this.$submitButton.focus();
            } else if (this.$submitButton.is($focused)) {
                this.$closeButton.focus();
            } else {
                this.$input.focus();
            }
        }
    }

    static init() {
        if ($('.js-search').length > 0) {
            new Search();
        }
    }
}

export default Search;
